/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {RestResponse} from '../model';
import {environment} from '../../environments/environment';
import {ApiHeaders} from './headers';

@Injectable()
export class ReportWatchProvider {

  constructor(
    private http: HttpClient
  ) {}

  startWatching(id: string): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/pma/report/${id}/watch`, null, ApiHeaders.getOptions());
  }

  stopWatching(id: string): Observable<RestResponse> {
    return this.http
      .delete<RestResponse>(`${environment.API_URL}/api/pma/report/${id}/watch`, ApiHeaders.getOptions());
  }

}
